<script lang="ts" setup>
defineProps({
    title: {
        type: String,
        required: false
    },
    messenges: {
        type: String,
        required: false
    }
});
</script>

<template>
    <div :toast-id="Math.random()">
        <h1 class="text-emerald-800 font-Inter text-sm font-medium leading-5 pb-1">{{ title }}</h1>
        <span class="text-emerald-700 font-inter text-sm font-normal leading-5">{{ messenges }}</span>
    </div>
</template>

<style>
.Vue-Toastification__toast {
    align-items: flex-start !important;
}

.Vue-Toastification__icon {
    margin: inherit !important;
    margin: 0px 10px 0px 0px !important;
}
</style>
